import PlanillasApi from "../../apis/Planillas";

export default {
  namespaced: true,
  state: {
    planillas: [],
  },
  mutations: {
    set_planillas(state, planillas) {
      state.planillas = planillas;
    },
  },
  actions: {
    async getPlanillas({ commit, dispatch }, filters) {
      return await PlanillasApi.get_all(filters)
        .then((response) => {
          // console.log("planillas = ", response);
          // console.log(response.data);
          commit("set_planillas", response.data);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al listar registros, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
  },
};
